import { Action, Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { Facade } from 'src/app/pago/models/Facade.model';

export class BaseFacade implements Facade {
  constructor(protected store: Store<AppState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
